import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from '../../../../theme/promoMedia';
import { PromoButton } from '../PromoButton/PromoButton';

const ButtonContainer = styled.div`
    text-align: center;

    ${promoMedia.desktop1440} {
        text-align: right;
    }
`;

export const BackToTopButton = (props) => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <ButtonContainer>
            <PromoButton caption={props.caption} variant={'secondary'} iconName={'arrow-up'} onClick={scrollToTop} />
        </ButtonContainer>
    );
};

BackToTopButton.propTypes = {
    caption: PropTypes.string,
};
